import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NavigationNode } from '@spartacus/storefront';
import { NavLabelComponent } from '../nav-label/nav-label.component';
import { NavArrowRightComponent } from './nav-arrow-right/nav-arrow-right.component';
import { SubMenuComponent } from './sub-menu/sub-menu.component';

@Component({
  selector: 'menu-mobile',
  standalone: true,
  imports: [CommonModule, NavLabelComponent, NavArrowRightComponent, SubMenuComponent],
  templateUrl: './menu-mobile.component.html',
  styleUrl: './menu-mobile.component.scss',
})
export class MenuMobileComponent {
  @Input() node!: NavigationNode;

  open(ev: any): void {
    const $btn = ev.currentTarget as HTMLElement;
    const $subMenu = $btn.closest('.js-menu-item')?.querySelector('.js-menu-list');

    $subMenu && $subMenu.classList.toggle('is-active');
  }

  removeUrl(node: NavigationNode) {
    return { ...node, url: '' };
  }
}
